<script setup>
import {ref} from "vue";
import MobileSidebarCategoryBranch from "@/components/ui/MobileSidebarCategoryBranch.vue";

defineProps({
  rootMenus: {
    type: Array,
    default: () => []
  },
  saleMenus: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits([
  'open-sale-overview',
  'navigate',
  'moved'
]);

const isOpen = ref(true);
const expandedRootId = ref(null);

function handleRootToggle(payload) {
  if (payload.depth !== 0) return;
  expandedRootId.value = payload.expanded ? payload.id : null;
}
</script>

<template>
  <section class="mobile-sidebar-card self-stretch grow shrink basis-0 transition-all duration-200">
    <div
      class="mobile-sidebar-primary-link"
    >
      <div>
        <div class="text-xs font-semibold uppercase tracking-[0.18em] text-stone-400">
          {{ $t("Chromaworks") }}
        </div>
        <div class="mt-1 text-xl font-semibold text-stone-700">
          {{ $t("All Products") }}
        </div>
      </div>
    </div>

    <div
      v-if="isOpen"
      class="flex flex-col gap-3"
    >
      <div class="border-t border-stone-300">
        <mobile-sidebar-category-branch
          v-for="(item, index) in rootMenus"
          :key="item.id"
          :item="item"
          :is-first="index === 0"
          :expanded="expandedRootId === item.id"
          @navigate="payload => emit('navigate', payload)"
          @toggle="handleRootToggle"
        />
      </div>
    </div>
  </section>
</template>

<style scoped>
.mobile-sidebar-card {
  @apply w-full  py-4 flex flex-col gap-3;
}

.mobile-sidebar-primary-link {
  @apply w-full bg-stone-100 px-4 py-4 flex items-center gap-3;
}

</style>
